export function getPublicSiteOrigin(): string {
  if (typeof window !== 'undefined') return window.location.origin
  return ''
}

export function slugifySegment(s: string): string {
  return (
    s
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 64) || 'artist'
  )
}

export function getTicketUrlPrefix(): string {
  const origin = getPublicSiteOrigin()
  return `${origin}/tickets/`
}

export function buildTicketPublicUrl(ticketSlug: string): string {
  const origin = getPublicSiteOrigin()
  if (ticketSlug) {
    return `${origin}/tickets/${encodeURIComponent(ticketSlug)}`
  }
  return `${origin}/tickets/`
}

export function buildTicketShowPublicUrl(
  ticketSlug: string,
  showSlugSegment?: string | null,
): string {
  const base = buildTicketPublicUrl(ticketSlug)
  const seg = (showSlugSegment || '').trim()
  if (!seg) return base
  const origin = getPublicSiteOrigin()
  const safe = slugifySegment(seg)
  return `${origin}/tickets/${encodeURIComponent(ticketSlug)}/${encodeURIComponent(safe)}`
}
